import { render, staticRenderFns } from "./SurveyFormCheckbox.vue?vue&type=template&id=8ae98146&scoped=true&"
import script from "./SurveyFormCheckbox.vue?vue&type=script&lang=js&"
export * from "./SurveyFormCheckbox.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8ae98146",
  null
  
)

export default component.exports